import React, { useEffect } from 'react';
import { Room, RoomEvent, RemoteParticipant, DataPacket_Kind } from 'livekit-client';

interface JoinRequestProps { room: Room; isOwner:boolean; onAccept:(identity:string)=>void; }
export const JoinRequestButton: React.FC<JoinRequestProps> = ({ room, isOwner, onAccept }) => {
  useEffect(() => {
    const handler = (payload: Uint8Array, participant?: RemoteParticipant) => {
      const msg = JSON.parse(new TextDecoder().decode(payload));
      if (msg.type==='joinRequest' && isOwner && participant) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`${participant.identity} quiere unirse. Aceptar?`)) {
          room.localParticipant.publishData(new TextEncoder()
            .encode(JSON.stringify({ type:'joinResponse', target: participant.identity, accepted:true })), DataPacket_Kind.RELIABLE);
          onAccept(participant.identity);
        } else {
          room.localParticipant.publishData(new TextEncoder()
            .encode(JSON.stringify({ type:'joinResponse', target: participant.identity, accepted:false })), DataPacket_Kind.RELIABLE);
        }
      }
      if (msg.type==='joinResponse' && !isOwner && msg.target===room.localParticipant.identity) {
        if (msg.accepted) { /* publicar tu cámara automáticamente */ }
        else alert('Tu petición fue rechazada');
      }
    };
    room.on(RoomEvent.DataReceived, handler);
    return ()=> room.off(RoomEvent.DataReceived, handler);
  }, [room, isOwner, onAccept]);

  // Sólo en viewer
  return !isOwner
    ? <button
        onClick={() => {
          console.log('[JoinRequestButton] enviando joinRequest');
          room.localParticipant.publishData(
            new TextEncoder().encode(JSON.stringify({ type:'joinRequest' })),
            DataPacket_Kind.RELIABLE
          );
        }}
        className="px-3 py-1 bg-gradient-to-r from-[#1c5290] to-[#45c0be] text-white rounded hover:opacity-90"
      >
        unirme
      </button>
    : null;
};
